const config = {
  BACKEND_URL: process.env.REACT_APP_SAAS_API_BASE_URL,
  
  ENDPOINTS: {
    COMPLETION: "/OpenAI/ChatGPTRequest",
    STREAM: "/Chat/Stream?useClaude=true"
  },
  
  CLAUDE_MODELS: {
    SONNET_3_5: "claude-3-5-sonnet-20241022",
    SONNET_3_7: "claude-3-7-sonnet-20250219", 
    SONNET_4: "claude-sonnet-4-20250514"
  },
  
  DEFAULTS: {
    anthropicVersion: "2023-06-01",
    model: "claude-sonnet-4-20250514",
    maxTokens: 8192,
    anthropicBeta: "max-tokens-3-5-sonnet-2024-07-15"
  },
  
  MODEL_CONFIGS: {
    "claude-sonnet-4-20250514": {
      maxTokens: 20000,
      anthropicBeta: "max-tokens-3-5-sonnet-2024-07-15"
    },
    "claude-3-7-sonnet-20250219": {
      maxTokens: 20000,
      anthropicBeta: "max-tokens-3-5-sonnet-2024-07-15"
    },
    "claude-3-5-sonnet-20241022": {
      maxTokens: 8192,
      anthropicBeta: "max-tokens-3-5-sonnet-2024-07-15"
    }
  }
};

export default config;

export const getModelConfig = (model) => {
  return config.MODEL_CONFIGS[model] || {
    maxTokens: config.DEFAULTS.maxTokens,
    anthropicBeta: config.DEFAULTS.anthropicBeta
  };
};

export const getMaxTokensForModel = (model, requestedTokens) => {
  const modelConfig = getModelConfig(model);
  return requestedTokens || modelConfig.maxTokens;
}; 